// extracted by mini-css-extract-plugin
var _1 = "TaskPrioritySelectItemContent-modulelabel__KYZes";
export { _1 as "label" }
